import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import RandomContent from '../Components/RandomContent';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GetPageContentBySlug } from '../services/apiservice';

const LoremIpsumGenerator = () => {
  const location = useLocation();
  const paramlink = location.pathname.replace('/', '');

  const [pageContent, setPageContent] = useState(null);

  const [type, setType] = useState('paragraphs');
  const [count, setCount] = useState(3);
  const [output, setOutput] = useState('');

  const LOREM_WORDS = [
    // Classical Lorem Ipsum (Cicero, de Finibus I)
    'lorem', 'ipsum', 'dolor', 'sit', 'amet', 'consectetur', 'adipiscing', 'elit',
    'sed', 'do', 'eiusmod', 'tempor', 'incididunt', 'ut', 'labore', 'et', 'dolore',
    'magna', 'aliqua', 'enim', 'ad', 'minim', 'veniam', 'quis', 'nostrud',
    'exercitation', 'ullamco', 'laboris', 'nisi', 'aliquip', 'ex', 'ea', 'commodo',
    'consequat', 'duis', 'aute', 'irure', 'in', 'reprehenderit', 'voluptate', 'velit',
    'esse', 'cillum', 'eu', 'fugiat', 'nulla', 'pariatur', 'excepteur', 'sint',
    'occaecat', 'cupidatat', 'non', 'proident', 'sunt', 'culpa', 'qui', 'officia',
    'deserunt', 'mollit', 'anim', 'id', 'est', 'laborum',
    // de Finibus II (perspiciatis section)
    'perspiciatis', 'unde', 'omnis', 'iste', 'natus', 'error', 'voluptatem',
    'accusantium', 'doloremque', 'laudantium', 'totam', 'rem', 'aperiam', 'eaque',
    'ipsa', 'quae', 'ab', 'illo', 'inventore', 'veritatis', 'quasi', 'architecto',
    'beatae', 'vitae', 'dicta', 'explicabo', 'nemo', 'ipsam', 'quia', 'voluptas',
    'aspernatur', 'aut', 'odit', 'fugit', 'consequuntur', 'magni', 'dolores', 'eos',
    'ratione', 'sequi', 'nesciunt', 'neque', 'porro', 'quisquam', 'dolorem', 'adipisci',
    'velit', 'numquam', 'eius', 'modi', 'tempora', 'incidunt', 'magnam', 'quaerat',
    'soluta', 'minima', 'nostrum', 'exercitationem', 'ullam', 'corporis', 'suscipit',
    'laboriosam', 'aliquid', 'commodi', 'consequatur', 'autem', 'vel', 'eum', 'iure',
    'quam', 'nihil', 'molestiae', 'illum', 'quo', 'harum',
    // de Finibus III (at vero section)
    'vero', 'accusamus', 'iusto', 'odio', 'dignissimos', 'ducimus', 'blanditiis',
    'praesentium', 'voluptatum', 'deleniti', 'atque', 'corrupti', 'quos', 'quas',
    'molestias', 'excepturi', 'occaecati', 'cupiditate', 'provident', 'similique',
    'mollitia', 'dolorum', 'fuga', 'harum', 'quidem', 'rerum', 'facilis', 'expedita',
    'distinctio', 'nam', 'libero', 'tempore', 'cum', 'soluta', 'nobis', 'eligendi',
    'optio', 'cumque', 'impedit', 'maxime', 'placeat', 'facere', 'possimus', 'assumenda',
    'repellendus', 'temporibus', 'quibusdam', 'officiis', 'debitis', 'necessitatibus',
    'saepe', 'eveniet', 'voluptates', 'repudiandae', 'molestiae', 'recusandae',
    'itaque', 'earum', 'tenetur', 'sapiente', 'delectus', 'reiciendis', 'voluptatibus',
    'maiores', 'alias', 'perferendis', 'doloribus', 'asperiores', 'repellat',
  ];

  const randomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

  const randomWord = () => LOREM_WORDS[Math.floor(Math.random() * LOREM_WORDS.length)];

  const buildSentence = () => {
    const words = Array.from({ length: randomInt(8, 16) }, randomWord);
    words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1);
    return words.join(' ') + '.';
  };

  const buildParagraph = () =>
    Array.from({ length: randomInt(3, 6) }, buildSentence).join(' ');

  useEffect(() => {
    GetPageContent();
  }, []);

  const GetPageContent = async () => {
    if (paramlink !== undefined && paramlink !== "") {
      try {
        const postMetaList = await GetPageContentBySlug(paramlink);
        const jsonMetaList = JSON.parse(postMetaList);
        setPageContent(jsonMetaList);
      } catch (error) {
        console.error('Error fetching the meta data:', error);
      }
    }
  };

  const generateLorem = () => {
    const num = Math.max(1, parseInt(count) || 1);
    let result = '';

    if (type === 'paragraphs') {
      result = Array.from({ length: num }, buildParagraph).join('\n\n');
    } else if (type === 'sentences') {
      result = Array.from({ length: num }, buildSentence).join('\n');
    } else if (type === 'words') {
      const words = Array.from({ length: num }, randomWord);
      words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1);
      result = words.join(' ');
    }

    setOutput(result);
  };

  const handleClear = () => {
    setCount(3);
    setType('paragraphs');
    setOutput('');
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(output);
    toast.success('Copied to clipboard!', { position: "top-right", autoClose: 2000 });
  };

  return (
    <>

      <Header />
      <RandomContent />

      {/* Info Section */}
      <div className="blog-area">
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            <div className="full-col col-lg-12 col-md-12">
              <div
                className="single-blog-inner shadow-sm p-4 mb-4"
                data-aos="fade-up"
                data-aos-duration="2800"
              >
                <div className="details">
                  <h4><a href="#">{pageContent?.section1header}</a></h4>

                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        pageContent?.section1text ||
                        '<p>Generate placeholder text for your projects quickly. Choose the number of paragraphs, sentences, or words and copy them instantly. 🚀</p>',
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Generator Section */}
      <div className="blog-area pb-20">
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            <div className="full-col col-lg-6 col-md-8">
              <div className="single-blog-inner p-5 shadow-lg rounded-3" data-aos="fade-up" data-aos-duration="2800">

                {/* Controls */}
                <div className="mb-3 d-flex gap-2 flex-wrap">
                  <div style={{ flex: 1 }}>
                    <label className="form-label">Type</label>
                    <select className="form-control" value={type} onChange={(e) => setType(e.target.value)}>
                      <option value="paragraphs">Paragraphs</option>
                      <option value="sentences">Sentences</option>
                      <option value="words">Words</option>
                    </select>
                  </div>
                  <div style={{ flex: 1 }}>
                    <label className="form-label">Count</label>
                    <input
                      type="number"
                      className="form-control"
                      min="1"
                      max="50"
                      value={count}
                      onChange={(e) => setCount(e.target.value)}
                    />
                  </div>
                </div>

                {/* Buttons */}
                <div className="d-flex gap-2 mb-3">
                  <button className="default-btn icon four" onClick={generateLorem}>Generate</button>
                  <button className="default-btn icon outline" onClick={handleClear}>Clear</button>
                  {output && <button className="default-btn icon outline" onClick={handleCopy}>Copy</button>}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Fullscreen Output Section */}
      {output && (
        <div className="lorem-output-area py-5 bg-light">
          <div className="container-block-fluid">
            <div className="row justify-content-center">
              <div className="full-col col-lg-10 col-md-12">
                <div className="single-blog-inner p-4 shadow-sm rounded-3" style={{ whiteSpace: 'pre-wrap', fontSize: '1rem', lineHeight: 1.6 }}>
                  {output}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Optional Bottom Content */}
      {pageContent?.section2text && (
        <div className="blog-area pt-20">
          <div className="container-block-fluid">
            <div className="row justify-content-center">
              <div className="full-col col-lg-12 col-md-12">
                <div
                  className="single-blog-inner p-4"
                  data-aos="fade-up"
                  data-aos-duration="2800"
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: pageContent.section2text,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Section 3 Below Boxes */}
      {pageContent?.section3text &&
        pageContent.section3text.trim() !== "" && (
          <div className="blog-area">
            <div className="container-block-fluid">
              <div className="row justify-content-center">
                <div className="full-col col-lg-12 col-md-12">
                  <div
                    className="single-blog-inner"
                    data-aos="fade-up"
                    data-aos-duration="2800"
                  >
                    <div className="details">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: pageContent.section3text,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      <Footer />
      <ToastContainer />

      <style jsx>{`
        .form-label {
          font-weight: 600;
          margin-bottom: 5px;
        }
        .d-flex button {
          flex: 1;
        }
        @media(max-width: 576px) {
          .d-flex, .d-flex > div {
            flex-direction: column !important;
            margin-bottom: 10px;
          }
        }
      `}</style>
    </>
  );
};

export default LoremIpsumGenerator;
